import { SortAscSvg, SortBaseSvg, SortDescSvg } from 'assets/icons';

export const SortBaseIcon = ({ sortingOrder, ...rest }) => <SortBaseSvg {...rest} />;
export const SortAscIcon = ({ sortingOrder, ...rest }) => <SortAscSvg {...rest} />;
export const SortDescIcon = ({ sortingOrder, ...rest }) => <SortDescSvg {...rest} />;
